export default class FieldValidator {
  constructor(key, rules) {
    this.key = key
    this.validate = this.combineRules(rules)
  }

  combineRules = rules => (value, cmp) => {
    return rules.reduce((acc, rule) => {
      const result = rule(value, cmp)
      if (result !== undefined) {
        acc.push(result)
      }
      return acc
    }, [])
  }
}
